/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Message_ConfirmInputs */

const en_delete_message_confirm = /** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this message? This cannot be undone.`)
};

const es_delete_message_confirm = /** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que quieres eliminar este mensaje? Esto no se puede deshacer.`)
};

const fr_delete_message_confirm = /** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer ce message ? Cette action est irréversible.`)
};

const de_delete_message_confirm = /** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bist du sicher, dass du diese Nachricht löschen möchtest? Dies kann nicht rückgängig gemacht werden.`)
};

const id_delete_message_confirm = /** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda yakin ingin menghapus pesan ini? Tindakan ini tidak dapat dibatalkan.`)
};

/** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */
const ja_delete_message_confirm = en_delete_message_confirm;

/** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */
const zh_delete_message_confirm = en_delete_message_confirm;

/** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */
const ar_delete_message_confirm = en_delete_message_confirm;

/** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */
const it_delete_message_confirm = en_delete_message_confirm;

/** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */
const ru_delete_message_confirm = en_delete_message_confirm;

/** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */
const pt_delete_message_confirm = en_delete_message_confirm;

/** @type {(inputs: Delete_Message_ConfirmInputs) => LocalizedString} */
const ko_delete_message_confirm = en_delete_message_confirm;

/**
* | output |
* | --- |
* | "Are you sure you want to delete this message? This cannot be undone." |
*
* @param {Delete_Message_ConfirmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delete_message_confirm = /** @type {((inputs?: Delete_Message_ConfirmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Message_ConfirmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_message_confirm(inputs)
	if (locale === "es") return es_delete_message_confirm(inputs)
	if (locale === "fr") return fr_delete_message_confirm(inputs)
	if (locale === "de") return de_delete_message_confirm(inputs)
	if (locale === "ja") return ja_delete_message_confirm(inputs)
	if (locale === "zh") return zh_delete_message_confirm(inputs)
	if (locale === "ar") return ar_delete_message_confirm(inputs)
	if (locale === "id") return id_delete_message_confirm(inputs)
	if (locale === "it") return it_delete_message_confirm(inputs)
	if (locale === "ru") return ru_delete_message_confirm(inputs)
	if (locale === "pt") return pt_delete_message_confirm(inputs)
	return ko_delete_message_confirm(inputs)
});